import {PaymentMethodDao} from '../../dao';
import {ErrorModel} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_PAYMENT_METHOD';

export async function deletePaymentMethod(
    userData: Record<string, string>,
    paymentMethodId: number
) {
    try {
        const result = await PaymentMethodDao.deletePaymentMethod(userData.userToken, paymentMethodId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
